<template>
  <div class="contents">
    <div class="content-head">
      <p class="menu">
        <span @click="$router.push({ name: 'environment' })">环境库</span><span class="line">/</span
        ><span @click="$router.push({ name: 'environment-detail', params: { id: $route.query.env_id }, query: { tab: 4 } })">案例</span>
      </p>
      <p class="name">{{ detail.name }}</p>
    </div>
    <div class="content-bottom">
      <div class="content-bottom-left">
        <p class="name">{{ detail.name }}</p>
        <p class="author">
          <span class="tit">作者</span><span>{{ detail.author }}</span>
        </p>
        <p class="tit">包含</p>
        <ul class="type-tag">
          <li v-if="detail.code_link">
            <Img src="/icon-case-code-b.png" />
            <span>代码</span>
          </li>
          <li v-if="detail.show_link">
            <Img src="/icon-case-yanshi-b.png" />
            <span>演示</span>
          </li>
          <li v-if="detail.parse_link">
            <Img src="/icon-case-jiexi-b.png" />
            <span>解析</span>
          </li>
        </ul>
        <p class="tit">类别</p>
        <ul class="tap">
          <li v-for="items in detail.tags" :key="items">#{{ items }}</li>
        </ul>
        <p class="tit">介绍</p>
        <ul class="des">
          {{
            detail.introduction
          }}
        </ul>
      </div>
      <div class="content-bottom-right">
        <p class="head">
          <span>代码</span>
        </p>
        <div class="iframes">
          <div class="mask">
            <Button type="primary" @click="openLink(detail.code_link)">前往代码库</Button>
          </div>
          <iframe :src="detail.code_link" width="100%" height="100%" />
        </div>
        <p class="link">
          <span class="name">演示</span>
          <Input v-model="detail.show_link" disabled class="w500" />
          <Button type="primary" @click="openLink(detail.show_link)">打开链接</Button>
        </p>
        <p class="link">
          <span class="name">解析</span>
          <Input v-model="detail.parse_link" disabled class="w500" />
          <Button type="primary" @click="downloadFiles(detail.parse_link)">下载解析</Button>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import Img from '../../components/Img.vue'
import { Input, Button, Message } from 'view-design'
import { downloadFile } from '../../utils/index'
export default {
  components: { Img, Input, Button },
  data() {
    return {
      detail: {
        name: '',
        author: '',
        introduction: '',
        code_link: '',
        show_link: '',
        parse_link: '',
        tags: []
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      const params = {
        uriCode: 'API021',
        id: this.$route.query.id
      }
      const res = await this.$fetch(params)
      this.detail = res
    },
    //打开链接
    openLink(url) {
      if (!url) {
        Message.warning('无演示地址!')
        return
      }
      window.open(url, 'code')
    },
    downloadFiles(url) {
      if (!url) {
        Message.warning('无解析文件地址!')
        return
      }
      downloadFile(url)
    }
  }
}
</script>
<style lang="scss" scoped>
.contents {
  max-width: 1440px;
  margin: auto;
  .content {
    &-head {
      border-radius: 8px;
      background-color: #fff;
      padding: 16px 24px;
      margin-top: 10px;
      .menu {
        span {
          cursor: pointer;
          line-height: 22px;
        }
        .line {
          margin: 0 8px;
          cursor: default;
        }
      }
      .name {
        line-height: 28px;
        font-size: 20px;
        font-weight: 500;
        margin-top: 16px;
        color: rgba(0, 0, 0, 0.85);
      }
    }
    &-bottom {
      margin-top: 10px;
      border-radius: 8px;
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      &-left {
        background-color: #fff;
        width: 460px;
        height: calc(100vh - 190px);
        overflow-y: auto;
        margin-right: 10px;
        border-radius: 8px;
        padding: 40px 30px;
        .name {
          font-size: 18px;
          font-weight: 400;
          color: #1c2a34;
          line-height: 25px;
        }
        .author {
          color: #1c2a34;
          margin-top: 12px;
          line-height: 22px;
          .tit {
            font-weight: 400;
            color: rgba(28, 42, 52, 0.45);
            margin-right: 5px;
            font-size: 14px;
          }
        }
        .tit {
          font-weight: 400;
          color: rgba(28, 42, 52, 0.65);
          line-height: 22px;
          font-size: 16px;
          margin-top: 40px;
        }
        .type-tag {
          margin-top: 20px;
          display: flex;
          flex-wrap: wrap;
          li {
            line-height: 30px;
            background-color: rgba(70, 143, 239, 0.06);
            color: #000;
            border-radius: 4px;
            padding: 0 14px;
            margin-right: 15px;
            color: #468fef;
            img {
              height: 16px;
              height: 16px;
              margin-right: 6px;
            }
          }
        }
        .tap {
          margin-top: 20px;
          display: flex;
          flex-wrap: wrap;
          li {
            background: rgba(70, 143, 239, 0.05);
            border-radius: 12px;
            line-height: 24px;
            color: #468fef;
            padding: 0 10px;
          }
        }
        .des {
          margin-top: 20px;
          font-weight: 400;
          color: rgba(28, 42, 52, 0.65);
          line-height: 22px;
          font-size: 16px;
        }
      }
      &-right {
        background-color: #fff;
        border-radius: 8px;
        padding: 16px 30px;
        flex: 1;
        height: calc(100vh - 190px);
        overflow-y: auto;
        .head {
          display: flex;
          flex-wrap: nowrap;
          justify-content: space-between;
          font-size: 16px;
          font-weight: 500;
          color: #1c2a34;
          .ivu-btn {
            border-radius: 4px;
            width: 137px !important;
            line-height: 30px;
            height: 30px;
            padding: 0 18px;
          }
        }
        .iframes {
          height: 500px;
          margin-top: 27px;
          margin-bottom: 8px;
          border: 1px solid rgba(28, 42, 52, 0.1);
          position: relative;
          .mask {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 99;
            opacity: 0;
            transition: all 0.4s ease-in-out;
            background-color: rgba(0, 0, 0, 0.2);
          }
        }
        .iframes:hover {
          .mask {
            opacity: 1;
          }
        }
        .link {
          line-height: 32px;
          display: flex;
          flex-wrap: nowrap;
          margin-top: 24px;

          .name {
            font-size: 16px;
            font-weight: 500;
            color: #1c2a34;
            line-height: 32px;
            margin-right: 20px;
            width: 40px;
          }
        }
      }
    }
  }
  .w500 {
    width: 500px;
    margin-right: 10px;
  }
}
</style>
